/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MemberId/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function MemberId({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/MemberId",
  onChange
  
}) {
let assignDetailsOnlyCoverageValueData = fromData.useDataValue({ viewPath,
context: 'assign_details',
path: 'onlyCoverage',
})
let txCategoryInsuredInsuredInsuranceSubscriptionMemberIdValueData = fromData.useDataValue({ viewPath,
context: 'tx_category_insured',
path: 'insured.insurance_subscription.member_id',
})
let txCategoryInsuredInsuredInsuranceSubscriptionMemberIdChangeData = fromData.useDataChange({ viewPath,
context: 'tx_category_insured',
path: 'insured.insurance_subscription.member_id',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="assign_details.onlyCoverage"
 disabled={assignDetailsOnlyCoverageValueData}
 data="tx_category_insured.insured.insurance_subscription.member_id"
 value={txCategoryInsuredInsuredInsuranceSubscriptionMemberIdValueData}
 onChange={txCategoryInsuredInsuredInsuranceSubscriptionMemberIdChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Member ID"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}